import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CheckIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27.0259 6L11.7405 19.274L5.2762 12.8165L1 16.5674L11.4434 27L31 10.0325L27.0259 6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
